export default __webpack_public_path__ + "static/media/PathEdgeMarker.6abe60b6.svg";